// Formatting helpers pour l'affichage des dates au format français JJ/MM/AAAA
// Utilisé partout dans l'app pour uniformiser les affichages (kanban, tables, listes...)

/**
 * Convertit une date ISO (YYYY-MM-DD ou ISO datetime) en JJ/MM/AAAA.
 * Retourne "" si l'input est vide/invalide.
 */
export function fmtFR(iso) {
  if (!iso) return "";
  // Accepte "YYYY-MM-DD" ou "YYYY-MM-DDTHH:MM:SS..." — on garde les 10 premiers caractères
  const s = String(iso).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return String(iso); // fallback : renvoie tel quel si format inattendu
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** Format long : "vendredi 1 mai 2026" — pour titres et bannières. */
export function fmtLongFR(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  } catch {
    return String(iso);
  }
}

/** Format date + heure JJ/MM/AAAA HH:MM (pour timestamps type accepted_at). */
export function fmtDateTimeFR(iso) {
  if (!iso) return "";
  const s = String(iso);
  const dPart = fmtFR(s);
  const tMatch = s.match(/T(\d{2}):(\d{2})/);
  return tMatch ? `${dPart} ${tMatch[1]}:${tMatch[2]}` : dPart;
}
